<template>
    <div>
        <label
            :for="name"
            class="block pl-5 text-left"
            >{{ label }}</label
        >
        <input
            :id="name"
            :type="type"
            :name="name"
            :value="modelValue"
            class="mt-2 w-full rounded-sm p-4 text-dark"
            :class="{ 'bg-red-light': errors.length }"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <div class="h-9">
            <template v-if="errors">
                <template
                    v-for="error in errors"
                    :key="error"
                >
                    <p class="pt-1 pl-5 text-sm text-red">
                        {{ error }}
                    </p>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeFormString',
    props: {
        type: { type: String, default: 'text' },
        name: { type: String, required: true },
        modelValue: { type: String, default: null },
        label: { type: String, required: true },
        errors: { type: Array, default: () => [] },
    },
    emits: ['update:modelValue'],
};
</script>
